"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
var moment_1 = __importDefault(require("moment"));
var getMinimalOrderDate_1 = require("../utils/getMinimalOrderDate");
exports.CreateOrderValidationSchema = function (t) {
    return yup.object({
        amount: yup
            .number()
            .integer()
            .max(999999)
            .min(5)
            .required(),
        pickupLocation: yup.string().required(),
        comments: yup.string().max(256),
        pickupDate: yup
            .date()
            .required()
            .test('dateBefore', t('errors:illegalDate'), function (value) {
            var selectedDate = moment_1.default(value);
            var minimalDate = moment_1.default(getMinimalOrderDate_1.getMinimalOrderDate());
            console.info("User date: " + selectedDate.format() + "\nServer date: " + minimalDate.format());
            var isSameOrAfterMinimal = selectedDate
                .startOf('day')
                .isSameOrAfter(minimalDate.startOf('day'));
            return isSameOrAfterMinimal;
        }),
    });
};
exports.OrderStatusValidationSchema = function () {
    return yup.object({
        status: yup
            .string()
            .required()
            .oneOf(['AWAITING', 'PROCESSING', 'DELIVERED', 'CLOSED', 'CANCELED']),
    });
};
//# sourceMappingURL=order.js.map